import axios from 'axios';
import config from './config.json';

const axiosCreate = () => {
  const axiosInstance = axios.create({
    baseURL: `${config.protocol}://${config.ipServerGW}:${config.portServerGW}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });
  return axiosInstance;
};

export default axiosCreate;
